import { stringifyParams } from "./stringifyParams";

const fetchFrom = (
  path: string,
  params?: Record<string, boolean | string | number | string[]>,
  options?: RequestInit,
) => fetch(`${path}?${params ? stringifyParams(params) : ""}`, options);

export { fetchFrom };
